import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../utils/api.constants';
import {
  AclPage,
  AclRole,
  AclRoleDetail,
  BlobContainer,
  BulkSetPageAssignmentsRequest,
  BulkSetPageAssignmentsResponse,
  BulkSetPermissionsRequest,
  BulkSetPermissionsResponse,
  CreateRoleRequest,
  DcrType,
  RolePageAssignment,
  TablesColumnsResponse,
  UpdateRoleRequest
} from '../models/tenant-role.model';

@Injectable({
  providedIn: 'root'
})
export class TenantRolesService {

  constructor(private http: HttpClient) { }

  getRoles(tenantUid?: string, name?: string): Observable<AclRole[]> {
    let params = new HttpParams();
    if (tenantUid) {
      params = params.set('tenant_uid', tenantUid);
    }
    if (name) {
      params = params.set('name', name);
    }
    return this.http.get<AclRole[]>(API_ENDPOINTS.TENANT_ROLES.ROLES.LIST, { params });
  }

  createRole(payload: CreateRoleRequest): Observable<AclRole> {
    return this.http.post<AclRole>(API_ENDPOINTS.TENANT_ROLES.ROLES.LIST, payload);
  }

  getRole(id: number): Observable<AclRoleDetail> {
    return this.http.get<AclRoleDetail>(API_ENDPOINTS.TENANT_ROLES.ROLES.DETAIL(id));
  }

  updateRole(id: number, payload: UpdateRoleRequest): Observable<AclRole> {
    return this.http.patch<AclRole>(API_ENDPOINTS.TENANT_ROLES.ROLES.DETAIL(id), payload);
  }

  deleteRole(id: number): Observable<void> {
    return this.http.delete<void>(API_ENDPOINTS.TENANT_ROLES.ROLES.DETAIL(id));
  }

  getPages(isActive?: boolean): Observable<AclPage[]> {
    let params = new HttpParams();
    if (isActive !== undefined) {
      params = params.set('is_active', String(isActive));
    }
    return this.http.get<AclPage[]>(API_ENDPOINTS.TENANT_ROLES.PAGES.LIST, { params });
  }

  getPageAssignments(roleId: number): Observable<RolePageAssignment[]> {
    const params = new HttpParams().set('role', roleId);
    return this.http.get<RolePageAssignment[]>(API_ENDPOINTS.TENANT_ROLES.PAGE_ASSIGNMENTS.LIST, { params });
  }

  bulkSetPageAssignments(payload: BulkSetPageAssignmentsRequest): Observable<BulkSetPageAssignmentsResponse> {
    return this.http.post<BulkSetPageAssignmentsResponse>(API_ENDPOINTS.TENANT_ROLES.PAGE_ASSIGNMENTS.BULK_CREATE, payload);
  }

  bulkSetPermissions(payload: BulkSetPermissionsRequest): Observable<BulkSetPermissionsResponse> {
    return this.http.post<BulkSetPermissionsResponse>(API_ENDPOINTS.TENANT_ROLES.PERMISSIONS.BULK_CREATE, payload);
  }

  getContainers(tenantUid: string, roleId?: number): Observable<BlobContainer[]> {
    let params = new HttpParams();
    if (roleId) {
      params = params.set('role_id', roleId);
    }
    return this.http.get<BlobContainer[]>(API_ENDPOINTS.TENANT_ROLES.CONTAINERS.LIST(tenantUid), { params });
  }

  getTablesColumns(tenantUid: string, roleId?: number): Observable<TablesColumnsResponse> {
    let params = new HttpParams();
    if (roleId) {
      params = params.set('role_id', roleId);
    }
    return this.http.get<TablesColumnsResponse>(API_ENDPOINTS.TENANT_ROLES.TABLES_COLUMNS.LIST(tenantUid), { params });
  }

  getDcrTypes(tenantUid: string): Observable<DcrType[]> {
    return this.http.get<DcrType[]>(API_ENDPOINTS.TENANT_ROLES.DCR_TYPES.LIST(tenantUid));
  }
}
